import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import FooterNew from './components/FooterNew';
import HomePage from './pages/HomePage';
import WeddingsPage from './pages/WeddingsPage';
import KidsPartiesPage from './pages/KidsPartiesPage';
import CorporatePage from './pages/CorporatePage';
import FestivalsPage from './pages/FestivalsPage';
import PrivatePartiesPage from './pages/PrivatePartiesPage';
import SpecialOccasionsPage from './pages/SpecialOccasionsPage';
import PartnersPage from './pages/PartnersPage';
import VereenigingenPage from './pages/VereenigingenPage';
import GalleryPage from './pages/GalleryPage';


import AboutPage from './pages/AboutPage';
import FAQPage from './pages/FAQPage';
import RealStoriesPage from './pages/RealStoriesPage';
import ContactPage from './pages/ContactPage';

import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/weddings" element={<WeddingsPage />} />
            <Route path="/kids-parties" element={<KidsPartiesPage />} />
            <Route path="/corporate" element={<CorporatePage />} />
            <Route path="/festivals" element={<FestivalsPage />} />
            <Route path="/private-parties" element={<PrivatePartiesPage />} />
            <Route path="/special-occasions" element={<SpecialOccasionsPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/verenigingen" element={<VereenigingenPage />} />
            <Route path="/gallery" element={<GalleryPage />} />


            <Route path="/over-ons" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/real-stories" element={<RealStoriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <FooterNew />
      </div>
    </Router>
  );
}

export default App;